"use strict";

var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Base class for Ace Editor Components
 */
var react_1 = __importDefault(require("react"));
var ace_builds_1 = __importDefault(require("ace-builds"));
var AceEditorComponent = /*#__PURE__*/function (_react_1$default$Comp) {
  _inherits(AceEditorComponent, _react_1$default$Comp);
  function AceEditorComponent() {
    _classCallCheck(this, AceEditorComponent);
    return _possibleConstructorReturn(this, _getPrototypeOf(AceEditorComponent).apply(this, arguments));
  }
  _createClass(AceEditorComponent, [{
    key: "getText",
    /**************************
     *
     *
     * METHODS REQUIRED FROM SUBCLASSES
     *
     *
     **************************/
    value: function getText() {
      if (this.props.text) {
        return this.props.text;
      }
      throw Error("Internal error: 'text' attribute must be provided or subclasses must implement getText()");
    }
  }, {
    key: "getEditorMode",
    value: function getEditorMode() {
      return this.props.editorMode;
    }
    /**************************
     *
     *
     * PROTECTED METHODS
     *
     *
     **************************/
    /**
     * Load and setup the ace editor
     * @param el the element that will hold the ace editor.
     */
  }, {
    key: "setupEditor",
    value: function setupEditor(el) {
      this.editor = ace_builds_1.default.edit(el);
      this.editor.setShowPrintMargin(false);
      this.editor.setReadOnly(true);
      this.editor.setHighlightActiveLine(false);
      this.editor.setHighlightGutterLine(false);
      this.editor.setFontSize(this.props.fontSize + "px");
      this.editor.renderer.setShowGutter(false);
      this.editor.renderer.setPadding(0);
      this.editor.renderer.$cursorLayer.element.style.display = "none";
    }
    /**
     * listen to mouse events and report them to instantiator
     */
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this = this;
      if (!this.editor) {
        throw Error("Editor must be defined before adding listeners.");
      }
      var _this$props = this.props,
        characterSizeChanged = _this$props.characterSizeChanged,
        mouseDown = _this$props.mouseDown,
        mouseMove = _this$props.mouseMove;
      function getMousePosition(editor, event) {
        var pos = event.getDocumentPosition();
        var screenCoordinates = editor.renderer.textToScreenCoordinates(pos.row, pos.column);
        return {
          mouseRow: pos.row,
          mouseColumn: pos.column,
          mousePageX: screenCoordinates.pageX,
          mousePageY: screenCoordinates.pageY
        };
      }
      this.editor.on("mousemove", function (e) {
        if (mouseMove) {
          mouseMove(getMousePosition(_this.editor, e));
        }
      });
      this.editor.on("mousedown", function (e) {
        if (mouseDown) {
          mouseDown(getMousePosition(_this.editor, e));
        }
      });
      this.editor.renderer.on("changeCharacterSize", function (e) {
        if (characterSizeChanged) {
          characterSizeChanged(e.data.width);
        }
      });
    }
    /**
     * update the text in the editor and set the editor to use that
     * mode (if provided).
     * @param newText
     * @param modeName the mode name for highlighting this ace editor. For alignments, this can
     *                 be defined as follows:
     *    const modeName = "ace/mode/" + this.props.alignment.getName();
     *    defineNewAlignmentMode(modeName, this.props.alignment);
     *    setText()
     * @throws an error if the editor is not yet defined.
     */
  }, {
    key: "setText",
    value: function setText() {
      if (!this.editor) {
        throw Error("Editor must be defined to call setText()");
      }
      //only update if needed
      if (this.props.fontSize + "px" !== this.editor.getFontSize()) {
        this.editor.setFontSize(this.props.fontSize + "px");
      }
      if (this.lastMode !== this.getEditorMode()) {
        var newMode = this.getEditorMode();
        this.editor.session.setMode(newMode);
        this.lastMode = newMode;
      }
      if (!this.lastText || this.lastText !== this.getText()) {
        this.editor.selectAll();
        this.editor.removeLines();
        var newText = this.getText();
        this.editor.insert(newText);
        this.lastText = newText;
      }
    }
    /**
     * The initial editor load function. Will only run a single time.
     * @param e the HTMLelment that will hold the ace editor
     */
  }, {
    key: "initialLoad",
    value: function initialLoad(e) {
      if (e && !this.editor) {
        //only run if editor not loaded
        this.element = e;
        this.lastElementWidth = e.clientWidth;
        this.lastElementHeight = e.clientHeight;
        this.setupEditor(e);
        this.addEventListeners();
        this.setText();
        if (this.props.editorLoaded) {
          this.props.editorLoaded(this.editor, e); //inform parent of loading.
        }
      }
    }
    /**************************
     *
     *
     * REACT METHODS
     *
     *
     **************************/
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.editor || !this.element) {
        throw Error("internal error - componentDidUpdate called before editor initialized");
      }
      this.setText(); //smart and will update only if needed.
      if (this.element.clientWidth !== this.lastElementWidth || this.element.clientHeight !== this.lastElementHeight) {
        this.lastElementWidth = this.element.clientWidth;
        this.lastElementHeight = this.element.clientHeight;
        this.editor.resize();
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return react_1.default.createElement("div", {
        className: this.props.classNames,
        onMouseEnter: function onMouseEnter() {
          if (_this2.props.mouseEnter) {
            _this2.props.mouseEnter();
          }
        },
        onMouseLeave: function onMouseLeave() {
          if (_this2.props.mouseLeave) {
            _this2.props.mouseLeave();
          }
        }
      }, react_1.default.createElement("div", {
        id: this.props.id,
        ref: function ref(e) {
          return _this2.initialLoad(e);
        }
      }));
    }
  }]);
  return AceEditorComponent;
}(react_1.default.Component);
exports.AceEditorComponent = AceEditorComponent;
AceEditorComponent.defaultProps = {
  fontSize: 14
};